import { useTranslation } from "react-i18next";
import Text from "../components/ingka/Text";
import Message from "../components/ingka/Message";
import { useEffect, useState } from "react";
import { levelsForMotion } from "../configuration/levelsForMotion";
import style from "../assets/scss/dashboard.module.scss"
import MotionLevelSelector from "../components/global/MotionLevelSelector";
import ProgressBar from "../components/global/ProgressBar";
import { useSessionStore } from "../store/sessionStore";
import { useCanvasStore } from "../store/canvasStore";
import { useStatistics } from "../hooks/use-statistics";
import { useMapsList } from "../hooks/use-maps-list";

export default function Dashboard() {
  const [t] = useTranslation("global")
  const levels = levelsForMotion
  const [levelSelected, setLevelSelected] = useState(null)
  const [showSelector, setShowSelector] = useState(false)
  const [progress, setProgress] = useState([
    {made:0, total:0, title: t('dashboard.completeArea')},
    {made:0, total:0, title: t('dashboard.sectionArea')},
    {made:0, total:0, title: t('dashboard.subSectionArea')},
  ])
  const {userName, myStore} = useSessionStore()
  const { maps, allMaps } = useCanvasStore()
  const { statistics } = useStatistics()
  const { loadMaps } = useMapsList()

  useEffect(() => {
    //if there arent all maps or maps is null, getMaps and save in store for first time
    if(!allMaps && !maps && myStore){
      loadMaps(myStore?.id)
    }
  }, [allMaps, maps, loadMaps, myStore])

  const openSelector = (level) => {
    setLevelSelected(level)
    setShowSelector(true)
  }

  useEffect(() => {
    if(statistics){
      setTimeout(() => {
        setProgress(statistics)
      }, 200)
    }
  }, [statistics])

  return (
    <div>
      <Text tagName="h2" headingSize="m">{t(`global.welcome`) + ", " + userName}</Text>
      <Text tagName="p" bodySize="m">{t(`dashboard.subtitle`)} {myStore.officeLocation}</Text>
      <div className="row">
        {levels?.map(level =>
            <div className="col-lg-4 col-md-6 col-sm-12" key={level.id}>
              <Message
                onClick={() => openSelector(level)}
                className={style.card}
                variant="informative"
                title={
                  <div  className={style.body}>
                    {t(level.title)}
                    <img src={level.img} alt="Level" className={style.image}/>
                  </div>
                }
              />
            </div>
        )}
      </div>

      {/* MOTIONS PROGRESS */}
      <div className="mt-3 mb-3">
        <Text tagName="h3" className="mb-0" headingSize="m">{t(`dashboard.progress`)}</Text>
          {progress.map((pr,index) => (
            <ProgressBar key={pr.title + index} made={pr.made} total={pr.total} title={pr.title}/>
          ))} 
      </div>

      {/* MODAL LEVEL SELECTOR FOR NEW MOTIONS */}
      <MotionLevelSelector 
      show={showSelector}
      level={levelSelected}
      hide={() => setShowSelector(!showSelector)}
      />
      
    </div>
  )
}
